import { TaskState } from "@coworker/apprestructured/src/tasks/enums/taskState";
import { TaskType } from "@coworker/apprestructured/src/tasks/enums/taskTypes";

// Except for the types above the types defined below also exists in task-service.
export enum TaskChangeType {
  TaskChangeAssignedUser = "task-change-assigned-user",
  TaskChangeAssignedTeam = "task-change-assigned-team",
  TaskChangeCreatorTaskStatusCompleted = "task-change-creator-task-status-completed",
  TaskChangeCreatorTaskStatusClosed = "task-change-creator-task-status-closed",
  TaskChangeCreatorAssignedUser = "task-change-creator-assigned-user",
  TaskChangeCreatorAssignedTeam = "task-change-creator-assigned-team",
}
interface ComponentType {
  type: string;
  props: object;
  components?: ComponentType[];
}

export interface UserType {
  userId: string;
  firstName: string;
  lastName: string;
  fullName: string;
}

export interface TeamType {
  teamId: string;
  name: string;
}

export function isUserType(
  userOrTeam: UserType | TeamType
): userOrTeam is UserType {
  return "userId" in userOrTeam;
}

export interface ItemInfoType {
  id: string;
  name: string;
  imageUrl: string;
  type: "ART" | "SPR" | "SCI";
}

export interface ComponentNotificationTitleAssigned extends ComponentType {
  type: "notification-title-assigned";
  props: {
    assignedBy: UserType;
    assignedTo: UserType | TeamType;
  };
}

export interface ComponentNotificationTitleCreatorStatus extends ComponentType {
  type: "notification-title-creator-status";
  props: {
    status: `${TaskState}`;
    statusChangeBy: UserType;
  };
}

export interface ComponentNotificationTitleCreatorAssigned extends ComponentType {
  type: "notification-title-creator-assigned";
  props: {
    assignedBy: UserType;
  };
}

export type ComponentNotificationTitle =
  | ComponentNotificationTitleAssigned
  | ComponentNotificationTitleCreatorStatus
  | ComponentNotificationTitleCreatorAssigned;

export interface ComponentNotificationBodyTaskTitleAndDescription extends ComponentType {
  type: "notification-body-title-and-description";
  props: {
    priority: boolean;
    safety: boolean;
    status: `${TaskState}`;
    title: string;
    description: string;
  };
}
export interface ComponentNotificationBodyProduct extends ComponentType {
  type: "notification-body-product";
  props: {
    priority: boolean;
    safety: boolean;
    status: `${TaskState}`;
    itemInfo: ItemInfoType | null;
  };
}
export interface ComponentNotificationBodyAssignedTitle extends ComponentType {
  type: "notification-body-assigned-title";
  props: {
    title: string;
    oldAssignedTo: UserType | TeamType;
    newAssignedTo: UserType | TeamType;
  };
}
export interface ComponentNotificationBodyAssignedProduct extends ComponentType {
  type: "notification-body-assigned-product";
  props: {
    itemInfo: ItemInfoType | null;
    oldAssignedTo: UserType | TeamType;
    newAssignedTo: UserType | TeamType;
  };
}
export type ComponentNotificationBody =
  | ComponentNotificationBodyTaskTitleAndDescription
  | ComponentNotificationBodyProduct
  | ComponentNotificationBodyAssignedTitle
  | ComponentNotificationBodyAssignedProduct;

export interface ComponentNotificationFooter extends ComponentType {
  type: "notification-footer";
  props: {
    taskType: `${TaskType}`;
  };
}

export interface ComponentNotificationTaskType extends ComponentType {
  type: "task-notification";
  props: {
    taskId: string;
    changeType: `${TaskChangeType}`;
  };
  components: [
    ComponentNotificationTitle,
    ComponentNotificationBody,
    ComponentNotificationFooter,
  ];
}
